<ion-header collapse="fade" translucent="true">
  <ion-toolbar>
    <ion-title>{{ "VENDORS.VENDORS" | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-menu-button />
    </ion-buttons>

    @if (pwaInstallStore.isInstallable()) {
      <ion-buttons slot="end" class="md:me-3">
        <mtjr-pwa-install-button />
      </ion-buttons>
    }
  </ion-toolbar>
  <ion-toolbar mode="ios" class="px-2">
    <div class="flex items-center">
      <ion-searchbar
        mode="ios"
        class="max-w-[550px] w-full flex-1 !p-0 !pe-1"
        [placeholder]="'COMMON.SEARCH' | translate"
        (ionChange)="handleSearchInput($event)"
        (ionClear)="handleSearchInput()"
        [value]="searchValue()"
      />
      <ion-button
        id="popover-trigger"
        color="light"
        mode="ios"
        fill="solid"
        style="--border-radius: 10px; --shadow: 0px"
        class="aspect-square !w-[38px] !shadow-none"
      >
        <ion-icon slot="icon-only" size="small" name="filter"></ion-icon>
      </ion-button>
      @if (store.vendorsListForVendorsInput().publishStatus !== undefined) {
        <div class="absolute -end-0.5 top-0.5 size-2 rounded-full bg-red-500"></div>
      }
    </div>

    <ion-popover trigger="popover-trigger" mode="ios" triggerAction="click" [dismissOnSelect]="true">
      <ng-template>
        <ion-content class="p-6">
          <ion-item
            lines="none"
            class="cursor-pointer hover:bg-medium/10"
            (click)="store.vendorsListForVendorsPage({ publishStatus: undefined })"
          >
            <ion-label>{{ "COMMON.ALL" | translate }}</ion-label>
            @if (!store.vendorsListForVendorsInput().publishStatus) {
              <ion-icon slot="end" color="success" size="small" name="checkmark-circle"></ion-icon>
            }
          </ion-item>
          @for (publishStatus of vendorPublishStatuses; track $index) {
            <ion-item
              lines="none"
              class="cursor-pointer hover:bg-medium/10"
              (click)="store.vendorsListForVendorsPage({ publishStatus })"
            >
              <ion-text
                class="capitalize"
                [ngClass]="{
                  'text-success': publishStatus === 'published',
                  'text-warning': publishStatus === 'waitingForReview',
                  'text-danger': publishStatus === 'rejected' || publishStatus === 'unPublished',
                  'text-medium': publishStatus === 'draft',
                }"
              >
                {{ "ENUMS.PublishStatus." + publishStatus | translate }}
              </ion-text>
              @if (store.vendorsListForVendorsInput().publishStatus === publishStatus) {
                <ion-icon slot="end" color="success" size="small" name="checkmark-circle"></ion-icon>
              }
            </ion-item>
          }
        </ion-content>
      </ng-template>
    </ion-popover>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen="true">
  @switch (store.vendorsListForVendorsState().type) {
    @case ("loading") {
      <mtjr-loading />
    }
    @case ("error") {
      <mtjr-error [failure]="store.vendorsFailure()" />
    }
    @case ("success") {
      <div
        data-cy="vendors-list"
        class="mt-4 grid gap-3 px-4 pb-36 grid-cols-1 md:grid-cols-[repeat(auto-fit,minmax(350px,1rem))]"
      >
        @for (vendor of store.vendors(); track $index) {
          <ion-card data-cy="vendor-card" class="!m-0 rounded-xl" [routerLink]="[vendor.id]" routerDirection="forward">
            <mtjr-blur-img
              proxy="https://dev-img.mtjr.ly/unsafe/resize:auto:1024:576/sm:1/q:85/plain/"
              [src]="vendor.background"
              [blurHash]="vendor.backgroundBlurHash"
              imgClass="h-32 w-full object-cover"
              alt=""
            />
            <div class="flex items-center">
              <div class="flex flex-1 flex-col ps-3 pb-3 pt-2">
                <ion-text color="dark" class="line-clamp-2 text-lg font-bold">
                  {{ vendor.name }}
                </ion-text>
                <ion-text color="medium" class="line-clamp-1 mt-1">
                  {{ vendor.addressStreet }}
                </ion-text>
              </div>
              <ion-text
                class="text-md mx-4 rounded-full px-2 py-1 capitalize border-solid border-[1px]"
                [ngClass]="{
                  'text-success bg-success/10 ': vendor.publishStatus === 'published',
                  'text-warning bg-warning/10': vendor.publishStatus === 'waitingForReview',
                  'text-danger bg-danger/10':
                    vendor.publishStatus === 'rejected' || vendor.publishStatus === 'unPublished',
                  'text-medium bg-medium/10': vendor.publishStatus === 'draft',
                }"
              >
                {{ "ENUMS.PublishStatus." + vendor.publishStatus | translate }}
              </ion-text>
            </div>
          </ion-card>
        } @empty {
          <div class="flex w-full min-h-[480px] flex-col items-center justify-center">
            <mtjr-dynamic-img
              src="/assets/no_products.svg"
              darkSrc="/assets/no_products_dark.svg"
              class="size-[180px] opacity-80 dark:opacity-70"
            />

            <p class="text-medium/70 mt-5 text-center">{{ "VENDORS.NO_VENDORS_TO_SHOW" | translate }}</p>
          </div>
        }
      </div>
    }
  }

  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>

<ion-fab vertical="bottom" horizontal="end">
  <ion-button color="primary" class="capitalize" data-cy="create-vendor-button" (click)="createVendor()">
    <ion-label>{{ "VENDORS.CREATE_VENDOR" | translate }}</ion-label>
    <ion-icon slot="start" class="!me-2" name="vendor-add"></ion-icon>
  </ion-button>
</ion-fab>
